import { TrialStatusResponse } from '@cast/types';

import { TrialState } from '../types';
import { getTrialState, isEligibleForTrial } from './get-trial-state';

type TrialAnalytics = {
  trialStatus: TrialState | 'none';
  isEligible: boolean;
  hasContactedSales: boolean;
};

export const getTrialAnalytics = (
  data: TrialStatusResponse
): TrialAnalytics => {
  const trialState = getTrialState(data);
  const isEligible = isEligibleForTrial(data.status);

  return {
    trialStatus: isEligible ? trialState : 'none',
    isEligible,
    hasContactedSales: data.salesContacted ?? false,
  };
};
